import { SchoolType } from './SchoolType'
import { Grade } from './Grade'
import { Region } from './Region'
import { School } from './School'
import { Subject } from './Subject'
import { Country } from './Country'
import { Currency } from './Currency'
import { LanguageInterface } from './Language'
import { Major } from './Major'
import { Course } from './Course'
import { AcademicTier } from './University'

export interface User {
    uuid: string
    name: string
    username: string
    bio: string | null
    createdOn: string
    profilePicture: string | null
    email: string
    interfaceLanguage: LanguageInterface
    schoolType: SchoolType | null
    grade: Grade | null
    issues: Subject[]
    active: boolean
    isActiveKnower: boolean
    country: Country
    region: Region | null
    knowerUuid: string | null
    school: School | null
    premiumStatus: UserPremiumStatus
    source: string | null
    sourceCampaign: string | null
    currency: Currency
    phoneNumber: string | null
    primaryContentLanguage: LanguageInterface
    utcTimeOffset: number
    hasUsedApp: boolean
    isAdmin?: boolean
    instagramUsername: string | null
    tiktokUsername: string | null
    followsCount: number
    isStaff: boolean
    academicTier: AcademicTier | null
    universityStartDate: string | null
    major: Major | null
    courses: Course[]
}

export enum UserPremiumStatus {
    None = 'NONE',
    Light = 'LIGHT',
    Pro = 'PRO',
}

export interface User2FAState {
    isActivated: boolean
}

export interface User2FASetupData {
    keyURI: string
    backupCodes: string[]
}

export interface NewUserPassword {
    newPassword: string
    oldPassword: string
}
